export class UliLoadSearchModel {
  loadNumber: string;
  exist: boolean;

  constructor(params?: UliLoadSearchModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
